import './src/theme/theme.scss'
import 'swiper/css'
import 'mapbox-gl/dist/mapbox-gl.css'

import SwiperCore, { Autoplay } from 'swiper'

SwiperCore.use(Autoplay as any)

export { wrapPageElement } from './src/providers'
